import MuiTextField from '@mui/material/TextField';
import type { TextFieldProps } from './ITextField';
import { styles } from './styles';

const TextField = ({ sx, ...rest }: TextFieldProps) => (
    <MuiTextField
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default TextField;
